import Constant from '@/const';
import axios from 'axios';

const getDialyVisits = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/daily'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDialyVisits;
